export default __webpack_public_path__ + "static/media/default-diamond.9c4da8ed.png";